(function () {
  'use strict';
  var root = document.querySelector('[data-ai-advisor]');
  if (!root) return;

  var VERSION = root.dataset.version || 'finder-v4';
  var questions = Array.from(root.querySelectorAll('[data-advisor-question]'));
  var resultPanel = root.querySelector('[data-advisor-results]');
  var resultList = root.querySelector('[data-advisor-result-list]');
  var noMatch = root.querySelector('[data-advisor-no-match]');
  var leadBox = root.querySelector('[data-advisor-lead-box]');
  var progressBar = root.querySelector('[data-advisor-progress-bar]');
  var progressLabel = root.querySelector('[data-advisor-progress-label]');
  var navigation = root.querySelector('[data-advisor-navigation]');
  var nextButton = root.querySelector('[data-advisor-next]');
  var hint = root.querySelector('[data-advisor-hint]');
  var resultsTitle = root.querySelector('[data-results-title]');
  var defaultResultsTitle = resultsTitle.textContent;
  var answerInput = root.querySelector('[data-advisor-answer-input]');
  var recommendationInput = root.querySelector('[data-advisor-recommendation-input]');
  var journeyInput = root.querySelector('[data-advisor-journey-input]');
  var noMatchInput = root.querySelector('[data-advisor-no-match-input]');
  var sourceInputs = Array.from(root.querySelectorAll('[data-advisor-source]'));
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var params = new URLSearchParams(window.location.search);
  var attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ad_id', 'adset_id', 'placement'];
  var attribution = resolveAttribution();
  var catalog = [];
  var state = {};
  var leadPayload = { answers: '', recommendations: '', noMatchReasons: '' };
  var current = 0;
  var hasStarted = false;
  var startedAt = 0;
  var advanceTimer = null;
  var journeyId = getJourneyId();

  try {
    var compiledCatalog = window.SRAdvisorCatalog && Array.isArray(window.SRAdvisorCatalog.candidates) ? window.SRAdvisorCatalog.candidates : null;
    var inlineCatalog = root.querySelector('[data-advisor-catalog]');
    var sourceCatalog = compiledCatalog || (inlineCatalog ? JSON.parse(inlineCatalog.textContent || '[]') : []);
    catalog = sourceCatalog.map(function (product) {
      if (product.priceCents) return product;
      var variantId = product.variant && product.variant.id ? String(product.variant.id).split('/').pop() : '';
      var url = product.url || ('/products/' + product.handle);
      if (variantId && url.indexOf('variant=') === -1) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
      var priceCad = product.variant && product.variant.priceCad ? product.variant.priceCad : product.priceCad;
      return {
        handle: product.handle, title: product.title, url: url,
        image: product.imageUrl || '', imageAlt: product.imageAlt || product.title,
        priceCents: Math.round(Number(priceCad) * 100),
        priceLabel: '$' + Number(priceCad).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' CAD',
        profile: product.profile || {}
      };
    });
  } catch (error) { catalog = []; }

  function getJourneyId() {
    var stored = '';
    try { stored = sessionStorage.getItem('sr_advisor_journey_id_v3') || ''; } catch (error) {}
    if (stored) return stored;
    var value = 'sr-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    try { sessionStorage.setItem('sr_advisor_journey_id_v3', value); } catch (error) {}
    return value;
  }

  function resolveAttribution() {
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem('sr_advisor_attribution_v4') || '{}') || {}; } catch (error) {}
    attributionKeys.forEach(function (key) {
      if (params.get(key)) saved[key] = params.get(key);
    });
    try { sessionStorage.setItem('sr_advisor_attribution_v4', JSON.stringify(saved)); } catch (error) {}
    return saved;
  }

  function attributionValue(key) { return attribution[key] || ''; }

  function publishOnce(eventName, fingerprint, properties) {
    var key = eventName + ':' + fingerprint;
    var published = {};
    try { published = JSON.parse(sessionStorage.getItem('sr_advisor_published_v4') || '{}') || {}; } catch (error) {}
    if (published[key]) return false;
    published[key] = Date.now();
    try { sessionStorage.setItem('sr_advisor_published_v4', JSON.stringify(published)); } catch (error) {}
    publish(eventName, properties);
    return true;
  }

  function publish(eventName, properties) {
    var payload = Object.assign({
      advisor_version: VERSION,
      journey_id: journeyId,
      page_path: window.location.pathname,
      catalog_count: catalog.length,
      catalog_snapshot: VERSION + ':' + catalog.length,
      elapsed_ms: startedAt ? Date.now() - startedAt : 0
    }, properties || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
    if (typeof window.gtag === 'function') window.gtag('event', eventName, payload);
    if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, payload);
    document.dispatchEvent(new CustomEvent('street_rides:' + eventName, { detail: payload }));
    root.dataset.advisorLastEvent = eventName;
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        var result = window.Shopify.analytics.publish('street_rides:' + eventName, payload);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      } catch (error) {}
    }
  }

  function begin() {
    if (hasStarted) return;
    hasStarted = true;
    startedAt = Date.now();
    publish('advisor_started', { total_steps: questions.length });
  }

  function scrollQuiz() {
    root.querySelector('[data-advisor-workspace]').scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
  }

  function persist() {
    try { sessionStorage.setItem('sr_advisor_answers_v3', JSON.stringify({ answers: state, step: current, attribution: attribution })); } catch (error) {}
  }

  function setQuestion(index, focusHeading) {
    current = Math.max(0, Math.min(index, questions.length - 1));
    questions.forEach(function (question, questionIndex) { question.hidden = questionIndex !== current; });
    resultPanel.hidden = true;
    navigation.hidden = false;
    hint.hidden = false;
    hint.removeAttribute('data-error');
    root.querySelector('[data-advisor-prev]').style.visibility = current === 0 ? 'hidden' : 'visible';
    nextButton.textContent = current === questions.length - 1 ? nextButton.dataset.resultLabel : nextButton.dataset.nextLabel;
    progressBar.style.width = (((current + 1) / questions.length) * 100) + '%';
    progressLabel.textContent = (current + 1) + ' / ' + questions.length;
    publishOnce('advisor_question_viewed', String(current + 1), { question_key: questions[current].dataset.key, step_number: current + 1 });
    if (focusHeading) {
      var heading = questions[current].querySelector('h2');
      if (heading) heading.focus({ preventScroll: true });
    }
  }

  var matcher = window.SRAdvisorMatcher;
  if (!matcher || typeof matcher.evaluate !== 'function') return;

  function evaluate(product) { return matcher.evaluate(product, state); }

  function element(name, className, text) {
    var node = document.createElement(name);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function trackedProductUrl(product, rank) {
    var url = new URL(product.url, window.location.origin);
    url.searchParams.set('advisor_journey_id', journeyId);
    url.searchParams.set('advisor_rank', String(rank));
    attributionKeys.forEach(function (key) {
      if (attributionValue(key)) url.searchParams.set(key, attributionValue(key));
    });
    return url.pathname + url.search;
  }

  function createResultCard(match, index) {
    var product = match.product;
    var profile = product.profile || {};
    var article = element('article', 'sr-ai-advisor__product');
    article.dataset.handle = product.handle;
    article.dataset.resultRank = String(index + 1);
    var media = element('div', 'sr-ai-advisor__product-media');
    var image = document.createElement('img');
    image.src = product.image;
    image.alt = product.imageAlt || product.title;
    image.loading = index === 0 ? 'eager' : 'lazy';
    image.width = 720;
    image.height = 540;
    media.appendChild(image);
    var body = element('div', 'sr-ai-advisor__product-body');
    body.appendChild(element('p', 'sr-ai-advisor__match-label', index === 0 ? root.dataset.labelBest : root.dataset.labelAlso));
    body.appendChild(element('h3', '', product.title));
    var price = element('p', 'sr-ai-advisor__price', product.priceLabel + ' ');
    price.appendChild(element('small', '', root.dataset.labelTax));
    body.appendChild(price);
    body.appendChild(element('p', 'sr-ai-advisor__why', matchExplanation()));
    var specs = element('ul', 'sr-ai-advisor__specs');
    if (profile.motorWatts) specs.appendChild(element('li', '', profile.motorWatts + ' W'));
    if (profile.maxRangeKm) specs.appendChild(element('li', '', 'Up to ' + profile.maxRangeKm + ' km claimed'));
    if (profile.maxLoadLb) specs.appendChild(element('li', '', profile.maxLoadLb + ' lb listed load'));
    if (specs.children.length) body.appendChild(specs);
    var tradeoff = root.dataset.labelCheck;
    if (profile.publicUse === 'yes') tradeoff = root.dataset.labelPublic;
    if (profile.publicUse === 'no') tradeoff = root.dataset.labelPrivate;
    var tradeoffLine = element('p', 'sr-ai-advisor__tradeoff');
    tradeoffLine.appendChild(element('strong', '', root.dataset.labelTradeoff + ' '));
    tradeoffLine.appendChild(document.createTextNode(tradeoff));
    body.appendChild(tradeoffLine);
    var actions = element('div', 'sr-ai-advisor__product-actions');
    var link = element('a', 'sr-ai-advisor__button', root.dataset.labelView);
    link.href = trackedProductUrl(product, index + 1);
    link.dataset.advisorProductLink = '';
    link.dataset.productHandle = product.handle;
    link.dataset.resultRank = String(index + 1);
    actions.appendChild(link);
    body.appendChild(actions);
    article.appendChild(media);
    article.appendChild(body);
    return article;
  }

  function matchExplanation() {
    var checks = ['your budget'];
    if (state.use === 'public') checks.push('a documented public-route configuration');
    if (state.job === 'cargo') checks.push('a cargo-rated bike');
    if (state.job === 'offroad') checks.push('off-road capability');
    if (state.distance) checks.push('your selected trip distance');
    if (state.terrain === 'rough') checks.push('rough-surface capability');
    if (state.fit === 'folding') checks.push('a folding frame');
    if (state.fit === 'lowstep') checks.push('a step-through frame');
    if (state.fit === 'folding-lowstep') checks.push('a folding step-through frame');
    if (state.load !== 'unsure') checks.push('the documented load rating');
    if (checks.length === 1) return 'Meets your stated budget. Other choices help order the shortlist.';
    return 'Meets the required checks for ' + checks.slice(0, -1).join(', ') + ' and ' + checks[checks.length - 1] + '.';
  }

  function failureSummary(evaluations) {
    var counts = {};
    evaluations.forEach(function (evaluation) {
      Array.from(new Set(evaluation.failures)).forEach(function (reason) { counts[reason] = (counts[reason] || 0) + 1; });
    });
    var labels = {
      budget: 'No verified in-stock option fits that maximum budget.',
      public_use: 'No candidate has a verified public-route configuration for the other choices.',
      cargo: 'No verified cargo-rated option fits the other choices.',
      terrain: 'No verified option fits that terrain and the other choices.',
      distance: 'No option documents enough range for that selected trip and the other choices.',
      fit: 'No option has the selected frame or storage format with the other choices.',
      load: 'No option has a documented load rating high enough for that selection.'
    };
    return Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; }).slice(0, 2).map(function (reason) { return labels[reason]; });
  }

  function showResults(quiet) {
    questions.forEach(function (question) { question.hidden = true; });
    progressBar.style.width = '100%';
    progressLabel.textContent = questions.length + ' / ' + questions.length;
    navigation.hidden = true;
    hint.hidden = true;
    resultList.replaceChildren();
    var evaluations = catalog.map(evaluate);
    var matches = evaluations.filter(function (item) { return item.score !== null; }).sort(function (a, b) {
      return b.score - a.score || Number(a.product.priceCents) - Number(b.product.priceCents);
    }).slice(0, 2);
    matches.forEach(function (match, index) { resultList.appendChild(createResultCard(match, index)); });

    var reasons = matches.length ? [] : failureSummary(evaluations);
    var reasonList = root.querySelector('[data-advisor-no-match-reasons]');
    reasonList.replaceChildren();
    reasons.forEach(function (reason) { reasonList.appendChild(element('li', '', reason)); });
    noMatch.hidden = matches.length > 0;
    resultsTitle.textContent = matches.length ? defaultResultsTitle : resultsTitle.dataset.emptyTitle;
    root.querySelector('[data-results-intro]').hidden = !matches.length;
    leadBox.hidden = false;
    resultPanel.hidden = false;

    var answerLabels = questions.map(function (question) {
      var selected = question.querySelector('[data-value="' + state[question.dataset.key] + '"]');
      return selected ? selected.textContent.trim() : '';
    });
    var summary = root.querySelector('[data-advisor-summary]');
    summary.replaceChildren();
    answerLabels.forEach(function (label) { summary.appendChild(element('span', '', label)); });
    var serializedAnswers = questions.map(function (question, index) { return question.querySelector('h2').textContent.trim() + ': ' + answerLabels[index]; }).join('\n');
    var handles = matches.map(function (match) { return match.product.handle; });
    leadPayload.answers = serializedAnswers;
    leadPayload.recommendations = handles.join(', ');
    leadPayload.noMatchReasons = reasons.join(' ');
    applyLeadPayload();
    current = questions.length;
    root.dataset.advisorResultCount = String(matches.length);
    persist();
    if (!quiet) {
      var resultFingerprint = questions.map(function (question) { return question.dataset.key + '=' + (state[question.dataset.key] || ''); }).join('&');
      publishOnce('advisor_completed', resultFingerprint, { answer_count: Object.keys(state).length, time_to_complete_ms: Date.now() - startedAt });
      publishOnce(matches.length ? 'advisor_results_viewed' : 'advisor_no_match_viewed', resultFingerprint, {
        result_count: matches.length,
        recommended_handles: handles.join('|'),
        result_scores: matches.map(function (match) { return match.score; }).join('|'),
        no_match_reasons: reasons.join('|')
      });
      resultPanel.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      resultsTitle.focus({ preventScroll: true });
    }
  }

  function advance() {
    if (!state[questions[current].dataset.key]) {
      hint.dataset.error = 'true';
      publish('advisor_question_error', { question_key: questions[current].dataset.key, step_number: current + 1, error_type: 'missing_answer' });
      questions[current].querySelector('[data-advisor-answer]').focus();
      return;
    }
    if (current < questions.length - 1) {
      setQuestion(current + 1, true);
      persist();
    } else showResults(false);
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-advisor-start]')) { begin(); scrollQuiz(); return; }
    var answer = event.target.closest('[data-advisor-answer]');
    if (answer) {
      var question = answer.closest('[data-advisor-question]');
      var key = question.dataset.key;
      var previous = state[key] || '';
      begin();
      state[key] = answer.dataset.value;
      question.querySelectorAll('[data-advisor-answer]').forEach(function (button) { button.setAttribute('aria-pressed', button === answer ? 'true' : 'false'); });
      publish('advisor_question_answered', { question_key: key, answer_key: answer.dataset.value, step_number: current + 1, answer_changed: previous && previous !== answer.dataset.value ? 'yes' : 'no' });
      hint.removeAttribute('data-error');
      persist();
      window.clearTimeout(advanceTimer);
      advanceTimer = window.setTimeout(advance, prefersReduced ? 350 : 220);
      return;
    }
    if (event.target.closest('[data-advisor-next]')) { window.clearTimeout(advanceTimer); advance(); return; }
    if (event.target.closest('[data-advisor-prev]') || event.target.closest('[data-advisor-back]')) { window.clearTimeout(advanceTimer); setQuestion(current - 1, true); persist(); return; }
    if (event.target.closest('[data-advisor-edit]')) { setQuestion(0, true); scrollQuiz(); return; }
    if (event.target.closest('[data-advisor-reset]')) {
      state = {};
      try { sessionStorage.removeItem('sr_advisor_answers_v3'); } catch (error) {}
      root.querySelectorAll('[data-advisor-answer]').forEach(function (button) { button.setAttribute('aria-pressed', 'false'); });
      publish('advisor_reset');
      setQuestion(0, true);
      scrollQuiz();
      return;
    }
    var productLink = event.target.closest('[data-advisor-product-link]');
    if (productLink) publish('advisor_product_clicked', { product_handle: productLink.dataset.productHandle || '', result_rank: Number(productLink.dataset.resultRank || 0) });
  });

  var form = root.querySelector('.sr-ai-advisor__form');
  if (form) {
    var formStarted = false;
    root.addEventListener('focusin', function (event) {
      if (!event.target.matches('input[type="email"]')) return;
      applyLeadPayload();
      if (!formStarted) { formStarted = true; publish('advisor_email_form_started'); }
    });
    root.addEventListener('submit', function () {
      applyLeadPayload();
      persist();
      var consent = root.querySelector('[name="contact[Marketing consent]"]');
      publish('advisor_email_submit_attempted', { marketing_consent: consent && consent.checked ? 'yes' : 'no', result_count: resultList.children.length });
    }, true);
  }

  function applyAttribution() {
    sourceInputs = Array.from(root.querySelectorAll('[data-advisor-source]'));
    sourceInputs.forEach(function (input) {
      var value = attributionValue(input.dataset.advisorSource);
      input.value = value;
      input.setAttribute('value', value);
    });
  }
  function setLeadField(selector, value) {
    var input = root.querySelector(selector);
    if (!input) return;
    if (input.value !== value) input.value = value;
    if (input.tagName === 'TEXTAREA') {
      if (input.textContent !== value) input.textContent = value;
    } else if (input.getAttribute('value') !== value) input.setAttribute('value', value);
  }
  function applyLeadPayload() {
    var attribution = sourceInputs.map(function (input) {
      var value = attributionValue(input.dataset.advisorSource);
      return value ? input.dataset.advisorSource + ': ' + value : '';
    }).filter(Boolean).join('\n');
    var bodyValue = [
      leadPayload.answers,
      'Recommended products: ' + (leadPayload.recommendations || 'No verified match'),
      'Advisor journey ID: ' + journeyId,
      'Finder rule version: ' + VERSION,
      leadPayload.noMatchReasons ? 'No-match reasons: ' + leadPayload.noMatchReasons : '',
      attribution
    ].filter(Boolean).join('\n\n');
    setLeadField('[data-advisor-answer-input]', bodyValue);
    setLeadField('[data-advisor-recommendation-input]', leadPayload.recommendations);
    setLeadField('[data-advisor-journey-input]', journeyId);
    setLeadField('[data-advisor-no-match-input]', leadPayload.noMatchReasons);
    applyAttribution();
  }
  applyLeadPayload();
  function suppressCampaignChat() {
    document.querySelectorAll('iframe').forEach(function (frame) {
      var signature = ((frame.src || '') + ' ' + (frame.title || '')).toLowerCase();
      if (signature.indexOf('inbox') !== -1 || signature.indexOf('shopify-chat') !== -1 || signature.indexOf('shopify chat') !== -1) frame.style.setProperty('display', 'none', 'important');
    });
  }
  suppressCampaignChat();
  new MutationObserver(suppressCampaignChat).observe(document.body, { childList: true, subtree: true });
  function publishPageView() {
    publishOnce('advisor_page_viewed', window.location.pathname, {
      campaign_source: attributionValue('utm_source'), campaign_medium: attributionValue('utm_medium'), campaign_name: attributionValue('utm_campaign'),
      campaign_content: attributionValue('utm_content'), meta_ad_id: attributionValue('ad_id'), meta_adset_id: attributionValue('adset_id'), placement: attributionValue('placement')
    });
  }
  function finalizePageLoad() {
    window.setTimeout(function () { applyLeadPayload(); publishPageView(); }, 0);
  }
  if (document.readyState === 'complete') finalizePageLoad();
  else window.addEventListener('load', finalizePageLoad, { once: true });

  try {
    var saved = JSON.parse(sessionStorage.getItem('sr_advisor_answers_v3') || 'null');
    if (saved && saved.answers && typeof saved.answers === 'object') {
      questions.forEach(function (question) {
        var value = saved.answers[question.dataset.key];
        question.querySelectorAll('[data-advisor-answer]').forEach(function (button) { if (button.dataset.value === value) { state[question.dataset.key] = value; button.setAttribute('aria-pressed', 'true'); } });
      });
      if (saved.step === questions.length && Object.keys(state).length === questions.length) showResults(true);
      else setQuestion(Math.min(Number(saved.step) || 0, questions.length - 1), false);
    } else setQuestion(0, false);
  } catch (error) { setQuestion(0, false); }

  if (root.querySelector('[data-advisor-success]')) { publishOnce('advisor_email_submitted', 'contact-success', { result_count: resultList.children.length }); leadBox.hidden = true; root.querySelector('[data-advisor-success]').scrollIntoView({ block: 'start' }); }
  if (root.querySelector('[data-advisor-form-errors]')) { leadBox.hidden = false; resultPanel.hidden = false; root.querySelector('[data-advisor-form-errors]').scrollIntoView({ block: 'center' }); }
})();
